import React from 'react';
import Icons, { IconNames } from './icons';
import { GREEN_LINE, BLUE_LINE } from './colorLine';

// const MAP_URL =
//   'https://www.samskip.com/skin/maps/?center=54,-6&mapZoom=4&mapType=roadmap&fullWidth=1&showLegend=true&showRoutes=iceland,icelandgreen,roam,nasoffices&showToggle=true&lang=is&activeLocationType=agent,office&v=v3';

const URL = 'https://www.samskip.com/skin/maps/';
const MAP_CONFIG = {
  center: [59, -9],
  mapZoom: 4,
  mapType: 'roadmap',
  fullWidth: 1,
  showLegend: true,
  showRoutes: ['iceland', 'icelandgreen'],
  showToggle: true,
  lang: 'en',
  activeLocationType: ['agent', 'office'],
  v: 'v3'
};

export default class VoyageMap extends React.Component {
  onDialogClick(event) {
    event.stopPropagation();
  }

  getMapUrlWithConfig(mapConfig) {
    let configStrings = [];

    for (const [key, value] of Object.entries(mapConfig)) {
      let config = `${key}=`;
      if (Array.isArray(value)) {
        config += value.join(',');
      } else {
        config += value;
      }
      configStrings.push(config);
    }

    return `${URL}?${configStrings.join('&')}`;
  }

  setLineToDisplay() {
    switch (this.props.lineType) {
      case GREEN_LINE:
        MAP_CONFIG.showRoutes = ['icelandgreen'];
        break;
      case BLUE_LINE:
        MAP_CONFIG.showRoutes = ['iceland'];
        break;
      default:
        MAP_CONFIG.showRoutes = ['iceland', 'icelandgreen'];
        break;
    }
  }

  render() {
    this.setLineToDisplay();
    const samskipMapIframe = `<iframe src=${this.getMapUrlWithConfig(MAP_CONFIG)} />`;

    return (
      <div>
        <a href="javascript:void(0)">
          <Icons
            iconName={IconNames.Cancel}
            iconClassName="vessel__info__close__icon"
            className="vessel__info__close"
            onClick={this.props.onClose}
          />
        </a>
        <div
          className="voyageMap"
          onClick={this.onDialogClick}
          dangerouslySetInnerHTML={{ __html: samskipMapIframe }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/voyageMap.js